import React from 'react';
import { Grid2, Button } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import useAlias from '@hooks/useAlias';

interface ClearFiltersButtonProps {
  onClick: () => void;
  disabled: boolean;
}

const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({
  onClick,
  disabled,
}) => {
  const alias = useAlias();

  return (
    <Grid2 size={{ xs: 12, sm: 6, md: 'auto' }}>
      <Button
        variant='outlined'
        size='small'
        onClick={onClick}
        startIcon={<ClearIcon />}
        disabled={disabled}
        sx={{ height: '40px' }}
      >
        {alias('Clear Filters')}
      </Button>
    </Grid2>
  );
};

ClearFiltersButton.displayName = 'ClearFiltersButton';

export default ClearFiltersButton;
